import { render, staticRenderFns } from "./endbox.vue?vue&type=template&id=215832e8&scoped=true"
import script from "./endbox.vue?vue&type=script&lang=js"
export * from "./endbox.vue?vue&type=script&lang=js"
import style0 from "./endbox.vue?vue&type=style&index=0&id=215832e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215832e8",
  null
  
)

export default component.exports